import { configureStore, Middleware } from '@reduxjs/toolkit'
import reduxLogger from 'redux-logger'
import rootReducer from 'state/reducers/rootReducer'

const middlewares: Middleware[] = []
if (process.env.NODE_ENV !== 'production') {
    //middlewares.push(reduxLogger)
}

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
})

// Define the AppDispatch type
export type AppDispatch = typeof store.dispatch;

export default store